import { z } from 'zod';
/**
 * Schémas Zod partagés pour l'authentification.
 * Utilisés à la fois par l'API (validation HTTP) et les fronts (formulaires).
 */
const passwordSchema = z
    .string()
    .min(12, 'Le mot de passe doit contenir au moins 12 caractères')
    .max(128, 'Le mot de passe est trop long');
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email('Email invalide')
    .max(255);
export const RegisterInputSchema = z
    .object({
    email: emailSchema,
    password: passwordSchema,
    displayName: z
        .string()
        .trim()
        .min(2, 'Le nom doit contenir au moins 2 caractères')
        .max(50, 'Le nom est trop long'),
})
    .strict();
export const LoginInputSchema = z
    .object({
    email: emailSchema,
    password: z.string().min(1).max(128),
})
    .strict();
export const RefreshTokenInputSchema = z
    .object({
    refreshToken: z.string().min(1),
})
    .strict();
export const AuthTokensSchema = z.object({
    accessToken: z.string(),
    accessTokenExpiresAt: z.string().datetime(),
});
export const AuthResponseSchema = z.object({
    user: z.object({
        id: z.string().uuid(),
        email: z.string().email(),
        displayName: z.string(),
    }),
    tokens: AuthTokensSchema,
});
//# sourceMappingURL=auth.schema.js.map